import manifest from "./imgManifest.json";

const SET = new Set(manifest.ids);
const STOCK = manifest.urls || {};
const RX = /^https:\/\/static\.prod-images\.emergentagent\.com\/.*\/images\/([0-9a-f]{16})[0-9a-f]{48}\.jpeg$/;
const LOCAL = /\/img\/d\/([0-9a-fu][0-9a-f]{15})(?:-600)?\.webp$/;

const idFor = (url) => { const l = LOCAL.exec(url || ""); if (l && SET.has(l[1])) return l[1]; const m = RX.exec(url || ""); if (m && SET.has(m[1])) return m[1]; const s = STOCK[url]; return s && SET.has(s) ? s : null; };

/* Generated hero/gallery JPEGs (~1 MB each) and the remaining Unsplash/Pexels photos are served as the 1200px WebP copy in public/img/d when one exists (scripts/optimize-images.mjs). `base` makes the URL absolute for og:image and JSON-LD. */
export function optimized(url, base = "") {
  const id = idFor(url);
  return id ? `${base}/img/d/${id}.webp` : url;
}

/* 600w + 1200w candidates for card-sized images; null for images without a local copy. */
export function srcSetFor(url, base = "") {
  const id = idFor(url);
  return id ? `${base}/img/d/${id}-600.webp 600w, ${base}/img/d/${id}.webp 1200w` : undefined;
}

export const CARD_SIZES = "(min-width: 1280px) 25vw, (min-width: 640px) 50vw, 100vw";
export const HERO_SIZES = "(min-width: 1280px) 1152px, 100vw";
export const SIDE_SIZES = "(min-width: 1024px) 40vw, 100vw";

/* AVIF + WebP candidates at 400/800/1200 (and 1600 when the source is that wide) written by scripts/optimize-images.mjs; null until an image has been converted. */
const W = manifest.w || {};
export function pictureFor(url, base = "") {
  const id = idFor(url);
  if (!id || !W[id]) return null;
  const ws = [400, 800, 1200, ...(W[id] >= 1600 ? [1600] : [])];
  return { avif: ws.map((w) => `${base}/img/d/${id}-${w}.avif ${w}w`).join(", "), webp: ws.map((w) => `${base}/img/d/${id}-${w}.webp ${w}w`).join(", "), src: `${base}/img/d/${id}-800.webp` };
}

export const optimizeDestination = (d, base = "") => ({ ...d, image: optimized(d.image, base), gallery: Array.isArray(d.gallery) ? d.gallery.map((u) => optimized(u, base)) : d.gallery });
